"use client";

import React from "react";
import { ArticleExpertCard, AyurvedaPregnancyCard, Typography } from "@aph/ui-lib-humanx";
import NextLink from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { CategoryIconType } from "@/components/PageHome/interfaces";
import IconPlus from "$/icons/icon-plus.svg";
import Bookmark from "@/components/BookmarkAction";
import { TYPE_ARTICLE } from "@/helpers/constants";
import routes from "@/helpers/router";
import { DeviceInfo } from "@/interface/deviceInfo";
import { ResourceArticlesComponent } from "@/components/PageAllResources/api/interface";
import styles from "../../PageAllResources.module.scss";

interface ArticleComponentProps {
  data: ResourceArticlesComponent;
  userAgent?: DeviceInfo;
  urlFilter?: any;
}

const ArticleComponent: React.FC<ArticleComponentProps> = ({ data, userAgent, urlFilter }) => {
  const articles = data?.data || [];
  const firstArticle = articles?.[0];

  const router = useRouter();

  const searchParams = useSearchParams();
  const queryString = searchParams?.toString();
  const seeAllLink = `${routes.resourcesListing(urlFilter, "articles")}${queryString ? `?${queryString}` : ""}`;

  return (
    <div className={styles.articleHead}>
      <div className={styles.head}>
        <Typography className={styles.heading}>
          All{" "}
          <Typography className={styles.heading} component="span" varient="body1" fontWeight="bold">
            articles
          </Typography>
        </Typography>
        {!!articles?.length && (
          <NextLink href={seeAllLink} prefetch={false} className={styles.primaryLink}>
            See all
          </NextLink>
        )}
      </div>
      {!!articles?.length ? (
        <div className={styles.articleContainer}>
          {!userAgent?.isMobile && (
            <ArticleExpertCard
              key={firstArticle?.Slug}
              iconType={CategoryIconType[firstArticle?.CategoryName]}
              className={styles.article}
              tagText={firstArticle?.CategoryName}
              imageUrl={firstArticle?.Image?.data?.attributes?.url}
              readTimeText={firstArticle?.ReadTime}
              doctorName={firstArticle?.AuthorName}
              doctorIcon={<IconPlus className={styles.iconPlus} width={20} height={20} />}
              ctaText={"Read more"}
              ctaClick={() => router.push(routes.article(firstArticle?.Slug))}
              rawTitle={firstArticle?.Title}
              redirectUrl={routes.article(firstArticle?.Slug)}
              rawSubTitle={firstArticle?.Description}
              isCircleIcon
              isImageCover
              bookmark={<Bookmark itemId={firstArticle?.id} type={TYPE_ARTICLE} />}
            />
          )}
          <div className={styles.sideArticle}>
            {articles.slice(!userAgent?.isMobile ? 1 : 0, 4)?.map((article, index) => {
              const { Slug, Title, AuthorName, ReadTime, Image } = article;
              const redirectUrl = routes.article(Slug);

              return (
                <div key={index} className={styles.articleCards}>
                  <AyurvedaPregnancyCard
                    ImageUrl={Image?.data?.attributes?.url}
                    title={Title}
                    labelText={ReadTime}
                    authorName={AuthorName}
                    authorIcon={<IconPlus width={13} height={13} />}
                    redirectUrl={redirectUrl}
                    onCardClick={() => router.push(redirectUrl)}
                    key={Slug}
                    eagerLoad={index <= 3}
                    cardBackground="#fff"
                    isBgStyle={false}
                    className={styles.mwebCardRoot}
                    isTitleHeight
                    bookmark={<Bookmark itemId={article?.id} type={TYPE_ARTICLE} />}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className={styles.noResourcesFound}>No articles available!</div>
      )}
    </div>
  );
};

export default ArticleComponent;
